import React, { useState, useEffect } from "react";
import { Button, Row, Col, ListGroup, Card, Container } from "react-bootstrap";
import { Image } from "cloudinary-react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Message from "../components/message";
import Loader from "../components/loader";
import SendOrderTrackingID from "../components/SendOrderTrackingID";
import {
  getOrderDetails,
  createSessionCheckoutWithStripe,
  payOrder,
  deliverOrder,
} from "../actions/order";
import { addDecimals } from "../Utils/addDecimals";
import { paymentDecode } from "../Utils/paymentDecode";
// Handling Stripe
import { useStripe } from "@stripe/react-stripe-js";
// Handling Paypal orders
// import paypalOrderScript from "../apis/api";
// import { PayPalButton } from "react-paypal-button-v2";
import { ORDER_PAY_RESET, ORDER_DELIVER_RESET } from "../actions/types";
import {
  currencyDecoder,
  stripeCurrencyDecoder,
} from "../Utils/currencyDecoder";
import { configUtil } from "../Utils/apiConfig";

const OrderScreen = ({ history, match }) => {
  const orderId = match.params.id;

  // State
  const [buttonLoading, setButtonLoading] = useState(false);
  const [stripeError, setStripeError] = useState(false);
  const [sdkReady, setSDKReady] = useState(false);

  // Get states from redux
  // Order Reducer
  const orderDetails = useSelector((state) => state.orderDetails);
  const { order, loading, error } = orderDetails;

  // Stripe Order Session
  const checkoutWithStripe = useSelector((state) => state.checkoutWithStripe);
  const { session, sessionId, sessionError } = checkoutWithStripe;

  // UserAuth Reducer
  const userAuth = useSelector((state) => state.userAuth);
  const { userInfo } = userAuth;
  console.log("userInfo__", userInfo);

  // Paypal reducer
  //   const orderPay = useSelector((state) => state.orderPay);
  //   const { paypalLoading, paypalSuccess } = orderPay;

  // Order Deliver Reducer
  const orderDeliver = useSelector((state) => state.orderDeliver);
  const { loading: loadingDeliver, success: successDeliver } = orderDeliver;

  const trackingState = useSelector((state) => state.orderTrackingId);
  const { success } = trackingState;

  useEffect(() => {
    if (success) {
      dispatch(getOrderDetails(orderId));
    }
  }, [success]);

  const dispatch = useDispatch();
  const stripe = useStripe();

  // paypal functioning
  useEffect(() => {
    // const addPayPalScript = async () => {
    //   const { data: clientId } = await paypalOrderScript.get(
    //     "/config/paypal",
    //     configUtil(userInfo.token)
    //   );

    //   const script = document.createElement("script");
    //   script.type = "text/javascript";
    //   script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=HKD`;
    //   script.async = true;
    //   script.onload = () => {
    //     setSDKReady(true);
    //   };
    //   document.body.appendChild(script);
    // };

    if (order) {
      if (order._id !== orderId) {
        dispatch(getOrderDetails(orderId));
      }
    }

    if (!order || successDeliver) {
      dispatch({ type: ORDER_PAY_RESET });
      dispatch({ type: ORDER_DELIVER_RESET });
      dispatch(getOrderDetails(orderId));
    } else if (!order.isPaid) {
      if (!window.paypal) {
        // addPayPalScript();
      } else {
        setSDKReady(true);
      }
    }

    if (!orderId) {
      history.push("/place-order");
    }
    if (!userInfo) {
      history.push("/login");
    }

    if (session) {
      setButtonLoading(true);
    }

    if (sessionError) {
      setButtonLoading(false);
    }
    if (sessionId) {
      const { error } = stripe.redirectToCheckout({
        sessionId,
      });
      if (error) {
        setStripeError(true);
      }
    }
  }, [
    dispatch,
    history,
    order,
    orderId,
    sessionId,
    session,
    userInfo,
    stripe,
    // paypalSuccess,
    sessionError,
    successDeliver,
  ]);

  // added history and session error to the dependency array, if any bugs occure, remove these two

  // Paypal payment handler
  const paypalSuccessPaymentHandler = (paymentResult) => {
    dispatch(payOrder(orderId, paymentResult));
  };

  // Stripe payment handler
  const placeOrderHandler = () => {
    const line_items = order.orderItems.map((item) => {
      return {
        price_data: {
          currency: "usd",
          product_data: {
            name: item.name,
            description: item.description
              ? item.description
              : "No description available",
            images: item.image[0],
          },
          unit_amount: item.discount,
        },
        quantity: item.qty,
      };
    });

    dispatch(
      createSessionCheckoutWithStripe(
        line_items,
        order.user.email,
        [paymentDecode(order.paymentMethod)],
        orderId,
        order.shippingCost,
        order.tax,
        "usd"
      )
    );
  };

  const deliverHandler = (e) => {
    e.preventDefault();
    if (window.confirm("Are you sure?")) {
      dispatch(deliverOrder(order._id || orderId));
    }
  };

  return order ? (
    <Container>
      {stripeError && (
        <Message variant="danger">Could not create Payment Session</Message>
      )}
      {sessionError && <Message variant="danger">{sessionError}</Message>}
      <h1>Order Number: #{order._id}</h1>
      <Row>
        <Col md={9}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Shipping Information</h2>
              <p>
                <strong>Name:</strong>
                {` ${order.user.name} ${order.user.surname}`}
              </p>
              <p>
                <strong>{"Email Address"}:</strong>
                <a
                  href={`mailto:${order.user.email}`}
                >{` ${order.user.email}`}</a>
              </p>
              {order?.trackingNumber && (
                <div style={{ display: "flex", gap: "5px" }}>
                  <strong>{"Tracking Number"}:</strong>
                  <p style={{ fontWeight: "600" }}>
                    {order?.trackingNumber || "Not generated"}
                  </p>
                </div>
              )}
              <p>
                <strong>Address:</strong>
                {` ${order.shippingAddress.address1}, ${order.shippingAddress.address2}, ${order.shippingAddress.city}, ${order.shippingAddress.country}`}
              </p>
              {order.isDelivered ? (
                <Message variant="success">{`Delivered on ${order.deliveredAt.substring(
                  0,
                  10
                )}`}</Message>
              ) : (
                <Message variant="danger">Not delievered</Message>
              )}
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Payment Method</h2>
              <p>
                <strong>Method: </strong>
                {order.paymentMethod}
              </p>
              {order?.isPaid ? (
                <Message variant="success">{`Paid on ${order.paidAt.substring(
                  0,
                  10
                )}`}</Message>
              ) : (
                <Message variant="danger">Not paid</Message>
              )}
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Order Items</h2>
              {order.orderItems.length === 0 ? (
                <Message variant="danger">Your order seems to be empty</Message>
              ) : (
                <ListGroup variant="flush">
                  {order.orderItems.map((item, index) => {
                    return (
                      <ListGroup.Item key={index}>
                        <Row
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          <Col>
                            <Image
                              cloudName={"dljielsye"}
                              width={50}
                              publicId={item.image[0]}
                              alt={item.name}
                            />
                          </Col>
                          <Col>
                            <Link
                              to={`/product/${item.productId}`}
                              style={{
                                textDecoration: "none",
                                color: "#0d6efd",
                              }}
                            >
                              {item.name}
                            </Link>
                          </Col>
                          <Col>
                            <h4 style={{ padding: 0, fontSize: "1.2rem" }}>
                              Capacity
                            </h4>{" "}
                            {item.capacity} GB
                          </Col>
                          <Col>
                            <h4 style={{ padding: 0, fontSize: "1.2rem" }}>
                              Color
                            </h4>{" "}
                            {item.color}
                          </Col>
                          <Col>
                            <h4 style={{ padding: 0, fontSize: "1.2rem" }}>
                              Price
                            </h4>{" "}
                            ${item.price - item.discount}
                          </Col>
                          <Col>
                            <h4 style={{ padding: 0, fontSize: "1.2rem" }}>
                              Quantity
                            </h4>{" "}
                            {item.qty}
                          </Col>
                          <Col>
                            <h4 style={{ padding: 0, fontSize: "1.2rem" }}>
                              Total
                            </h4>{" "}
                            ${(item.price - item.discount) * item.qty}
                          </Col>
                        </Row>
                      </ListGroup.Item>
                    );
                  })}
                </ListGroup>
              )}
            </ListGroup.Item>
            {userInfo && userInfo.role === "admin" && (
              <SendOrderTrackingID
                email={order?.user?.email}
                orderId={order?._id}
              />
            )}
          </ListGroup>
        </Col>

        <Col md={3}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>Order Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Items</Col>
                  <Col>${addDecimals(order.itemsPrice)}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Shipping</Col>
                  <Col>${addDecimals(order.shippingCost)}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Tax</Col>
                  <Col>${addDecimals(order.tax)}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Total</Col>
                  <Col>${addDecimals(order.totalPrice)}</Col>
                </Row>
              </ListGroup.Item>

              <ListGroup.Item>
                {!order.isPaid ? (
                  <div>
                    {
                      <span className="d-grid gap-2">
                        <Button
                          type="button"
                          disabled={
                            order.orderItems.length === 0 ||
                            order.isPaid ||
                            buttonLoading
                          }
                          onClick={placeOrderHandler}
                          style={{
                            backgroundColor: "black",
                            color: "white",
                            border: "1px solid black",

                            textAlign: "center",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#514f4f";
                            e.target.style.color = "white";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "black";
                            e.target.style.color = "white";
                          }}
                        >
                          Proceed to Payment
                        </Button>
                      </span>
                    }
                  </div>
                ) : null}
              </ListGroup.Item>
              {loadingDeliver && <Loader />}
              {userInfo &&
                userInfo.role !== undefined &&
                userInfo.role === "admin" &&
                order.isPaid &&
                !order.isDelivered && (
                  <ListGroup.Item>
                    <span className="d-grid gap-2" onClick={deliverHandler}>
                      <Button type="button">Mark as delivered</Button>
                    </span>
                  </ListGroup.Item>
                )}
              {userInfo && order.isPaid && order.isDelivered && (
                <ListGroup.Item>
                  <span className="d-grid gap-2">
                    <Button
                      type="button"
                      variant="success"
                      onClick={deliverHandler}
                    >
                      Mark as not Delivered
                    </Button>
                  </span>
                </ListGroup.Item>
              )}
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </Container>
  ) : loading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error}</Message>
  ) : (
    <></>
  );
};

export default OrderScreen;
